import { Form } from "react-bootstrap";
import { UnitsOfMeasure } from '../domain/UnitOfMeasure/model';

export function formatMoney(amount) {
    var aux = parseFloat(amount)
    return aux.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP', // Puedes cambiar esto según la moneda que necesites
        maximumFractionDigits: 0
    });
}

export function formatUnit(value) {
    return UnitsOfMeasure[value] || value;    
}

export function formatPrefix(prefix, id) {
    return `${prefix}-${id}`
}

export function formatTimeStamp(timestamp) {
    if (!timestamp) return "";

    // Check if it is a date string without time like YYYY-MM-DD
    if (typeof timestamp === "string" && timestamp.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = timestamp.split("-");
        // Keep the format day/month/year by just dropping the leading zero if there is any,
        // to maintain exactly the same behavior as date.getDate() and date.getMonth() + 1
        return `${parseInt(day)}/${parseInt(month)}/${year}`;
    }

    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`
}

export function formatPercentage(value) {
    const formated = parseFloat(value) * 100
    return `${formated}%`
}

export function formatBoolean(value) {
    return <Form.Check disabled={true} defaultChecked={value}/>
}

export function dynamicJsonMapper(json, path) {

    if (!json || !path) return undefined;

    const keys = path.split('.');
    let current = json;

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (current && typeof current === 'object' && key in current) {
            current = current[key];
        } else {
            return undefined; // O null, dependiendo de cómo quieras manejar las rutas no encontradas
        }
    }
    return current;
}
